<template>
	<div class="flex flex-col gap-[24px] w-full h-fit bg-white border border-grays-400 rounded py-[22px]  pl-[16px] pr-[36px]">
		<!-- Intro/Edit -->
		<div class="flex flex-col">
			<!-- Edit fields -->
			<div class="flex flex-col w-full gap-[14px]">
				<div class="flex flex-row w-full gap-[20px]">
					<input-default
						:label="'Last Name'"
						v-model="copyProfileData.lname"
					/>
					<input-default
						:label="'First Name'"
						v-model="copyProfileData.fname"
					/>
					<!-- <input-default
						v-for="phone in copyProfileData.phones"
						:key="phone"
						:label="'First Name'"
						v-model="phone.tel"
					/> -->
          <input-default
						:label="'First Phone'"
						v-model="copyProfileData.phone" 
					/>


			</div>
			<!-- Add one more phone number btn & input -->
		</div>
		<!-- Save chnages -->
		<div
		 class="flex flex-col items-end"
		>
			<button-secondary
				@click="handleSave"
			>
				save
			</button-secondary>
		</div>
	</div>
		</div>
</template>

<script>
export default {
	name: "child-component-test",

	props: {
		profileData: Object,
	},
	computed: {
    copyProfileData: {
      get() {
        return { ...this.profileData };
      },
      set(newValue) {
        this.$emit("save-profile", newValue);
      },
    },
  },

	methods: {
		handleSave() {
			this.$emit("save-profile", this.copyProfileData);
		}
	},
}
</script>

<style>

</style>